/**
 * ManualGradingPanel - Right sidebar component showing subjective/file upload questions that need manual grading
 */
import React from 'react';
import styles from './StudentSubmissionV2.module.css';

const ManualGradingPanel = ({ questions }) => {
  // Filter for questions that need manual grading (Subjective and File Upload)
  const manualGradingQuestions = questions.filter(
    (q) => q.question_type === 'D' || q.question_type === 'PA' || q.question_type === 'T' || q.question_type === 'U'
  );

  // Map question type to display name
  const getTypeName = (type) => {
    switch (type) {
      case 'D':
      case 'PA':
        return 'Subjective';
      case 'T':
        return 'Text';
      case 'U':
        return 'File Upload';
      default:
        return type;
    }
  };

  if (manualGradingQuestions.length === 0) {
    return null;
  }

  return (
    <div className={styles.gradingPanel}>
      <h6 className={styles.panelTitle}>Manual Grading</h6>

      <div className={styles.gradingTableWrapper}>
        <table className={styles.gradingTable}>
          <thead>
            <tr>
              <th>Id</th>
              <th>Type</th>
              <th>TA</th>
              <th>Status</th>
              <th>Marks</th>
            </tr>
          </thead>
          <tbody>
            {manualGradingQuestions.map((question, index) => {
              const response = question?.questionresponse_set || {};
              const isGraded = response.graded;
              const rawGradedBy = response.graded_by;
              const gradedBy =
                rawGradedBy && rawGradedBy !== 'NA' && rawGradedBy !== 'None' ? rawGradedBy : '-';
              const scoredMarks = response.scored_marks ?? '-';

              return (
                <tr key={question.id || index}>
                  <td>{index + 1}</td>
                  <td>{getTypeName(question.question_type)}</td>
                  <td className={styles.taCell}>{gradedBy}</td>
                  <td>
                    <span className={`${styles.statusBadge} ${isGraded ? styles.graded : styles.notGraded}`}>
                      {isGraded ? 'graded' : 'Not Graded'}
                    </span>
                  </td>
                  <td><strong>{scoredMarks}</strong></td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ManualGradingPanel;
